import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../config/config';
import React from 'react';
import { useSelector } from 'react-redux';

function List() {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getallemployees'
  }

  let list = {
    labelTitle: 'Lista de Colaboradores',
    icon: 'fa-users',
    filter: {
      friendly_url: friendly_url
    },
    columns: [
      {
        name: 'employeeid',
        label: 'ID',
        width: '5%'
      },
      {
        name: 'employee_name',
        label: 'Nome do Empregado',
        width: '20%'
      },
      {
        name: 'admission_date',
        label: 'Data de Admissão',
        width: '10%'
      },
      {
        name: 'role',
        label: 'Cargo',
        width: '20%'
      },
      {
        name: 'department',
        label: 'Departamento',
        width:'15%'
      },
      {
        name: 'situation',
        label: 'Situação',
        width: '10%'
      },
      {
        name: 'situation_date',
        label: 'Data Situação',
        width: '10%'
      }
    ]
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        canAdd={false}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
        icon={list.icon}
      />
    </div>
  );
}
export default List;
